// extracted by mini-css-extract-plugin
export var fullWidthImage = "fullWidthImage-module--fullWidthImage--827d4";
export var fullWidthImage__container = "fullWidthImage-module--fullWidthImage__container--6206d";
export var fullWidthImage__image = "fullWidthImage-module--fullWidthImage__image--45a12";